import { useDispatch } from "react-redux";
import Modal from "../../../../../components/Modal/Modal";
import Button, { ButtonType } from "../../../../../components/Button/Button";
import { updateFreightOption } from "../../../../../redux/actions/orders";
import { formatErrorMessage, isAirFreightError } from "./util";

interface Props {
  showRecalculateButton: boolean;
  setShowRecalculateButton: () => void;
  errorMessage: string | null;
  callSplitService: any;
}

const AirbagError = ({
  showRecalculateButton,
  setShowRecalculateButton,
  errorMessage,
  callSplitService,
}: Props) => {
  const dispatch = useDispatch();

  if (!isAirFreightError(errorMessage)) {
    return (
      <Modal>
        <div className="airbag-error-modal">
          <p>We couldn&apos;t process your order right now.</p>
          <p>
            Please try again in a few minutes. If the problem continues, contact Customer Service.
          </p>
          <Button type={ButtonType.primary} onClick={() => callSplitService()}>
            Try again
          </Button>
          <Button type={ButtonType.secondary} onClick={() => window.location.reload()}>
            Modify order
          </Button>
        </div>
      </Modal>
    );
  }

  return (
    <Modal>
      <div className="airbag-error-modal">
        <div>{formatErrorMessage(errorMessage)}</div>
        <p>
          You can fix this by changing your freight method or shipping address or by removing items
          in your cart causing the error.
        </p>
        {showRecalculateButton ? (
          <Button type={ButtonType.primary} onClick={() => callSplitService()}>
            Recalculate On-Road cost
          </Button>
        ) : (
          <Button
            type={ButtonType.primary}
            onClick={() => {
              dispatch(updateFreightOption("by_ground"));
              setShowRecalculateButton();
            }}
          >
            Change to road freight
          </Button>
        )}
        <Button type={ButtonType.secondary} onClick={() => window.location.reload()}>
          Modify order
        </Button>
      </div>
    </Modal>
  );
};

export default AirbagError;
